module.exports = __webpack_public_path__ + "static/media/hero-title.4116fa00.svg";